export interface SignInResult {
    status: SignInStatus;
    lockoutEndDate: string | null;
    requiresMfaSetup?: boolean;
    mustEnableTwoFactor?: boolean;
    twoFactorEnabled?: boolean;
    userId?: string;
    userEmail?: string;
}

export enum SignInStatus {
    Success = 1,
    Failed = 2,
    IsLockedOut = 3,
    IsBanned = 4,
    PasswordExpired = 5,
    CannotReuseOldPassword = 6,
    TwoFactorSetupRequired = 7,
    TwoFactorVerificationRequired = 8,
}
